module.exports = __webpack_public_path__ + "img/img13.f0b6b417.png";